/**
 * Class to manage router navigation stack
 * 
 */
import { INavigationStack } from './navigationStack.types'

export class NavigationStack implements INavigationStack {

    /** push the route to the stack */
    push(route: any) {

        /** Get from the local storage */
        var items = JSON.parse(localStorage.getItem('routeHistory') || '[]');

        items.push({
            "name": route.name,
            "hash": route.hash,
            "param": route.params
        });

        localStorage.setItem('routeHistory', JSON.stringify(items));
    } 

    /** pop the route from the stack */
    pop() {
        /** Get from the local storage */
        var items = JSON.parse(localStorage.getItem('routeHistory') || '[]');

        if(items.length === 0) {
            return undefined;
        }

        var item = items.pop();

        localStorage.setItem('routeHistory', JSON.stringify(items));

        return item;
    }

    /** return the top most element from the stack */
    peek() {
         /** Get from the local storage */
         var items = JSON.parse(localStorage.getItem('routeHistory') || '[]');

         if(items.length === 0) {
             return undefined;
         }

         return items[items.length - 1];
    }

    /** clear the stack */
    clear() {
        localStorage.setItem('routeHistory', '[]');
    }
}